import { action, makeObservable, observable } from 'mobx';
import Transport, { ITransport } from '~/state/store/Transport';

class PartialStore {

    /**
     * @protected
     */
    protected transports: {
        [endpoint: string]: ITransport;
    } = {};

    /**
     * @param apiService
     */
    public constructor(protected apiService: ITransport['http']) {
    }

    /**
     * @param endpoint
     */
    public load = (endpoint: string) => {
        return this.transport(endpoint).get('/partial/' + endpoint)();
    }

    /**
     * Transport factory
     *
     * @param endpoint
     */
    public transport(endpoint: string) {
        const transports = this.transports;

        if(!transports[endpoint]) {
            transports[endpoint] = new Transport(this.apiService);
        }

        return transports[endpoint];
    }
}

export default PartialStore;
